export const profileTabs = [
  {
    label: 'General',
    value: `/portal/profile/general`,
  },
];
